import { PriceDisplayReturn } from '@terminal/components/price-display-view/helpers/price-display.types';
import React from 'react';

import {
  LegendPriceIcons,
  PriceIcon,
} from '../legend-price-icons/LegendPriceIcons';
import styles from './LegendLivePrice.module.scss';

export interface LegendLivePriceProps {
  iconMapping: PriceIcon[];
  price: PriceDisplayReturn;
  legendColor: string;
  isPrimary: boolean;
  priceFormatter: (price: number) => string;
}

export const LegendLivePrice = ({
  iconMapping,
  price,
  legendColor,
  isPrimary,
  priceFormatter,
}: LegendLivePriceProps) => {
  return (
    <div className={styles.legendPriceRoot} data-testid="legend-live-price">
      {isPrimary &&
        iconMapping.map((icon, i) =>
          icon.shouldShow ? (
            <LegendPriceIcons key={i} iconInfo={icon} price={price} />
          ) : null
        )}

      {price.primary.price !== undefined && (
        <div
          className={styles.priceContainer}
          data-element="legend-price-container"
          style={{ color: legendColor }}
        >
          {priceFormatter(price.primary.price)}
          {price.primary.priceChange && (
            <>
              <span>{price.primary.priceChange.change}</span>
              <span>({price.primary.priceChange.proportionChange})</span>
            </>
          )}
        </div>
      )}
    </div>
  );
};
